import React from 'react';
import { useDispatch } from 'react-redux';

import { deleteTag } from '../../../../../../../common/tags/tagActions';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import Icon from '../../../../../../components/icons/Icon';

import { Tag } from '../../../../../../../common/tags/tagTypes';

type Props = {
    tag: Tag;
    closePopup: () => void;
};

const TagDeleteButton: React.FC<Props> = ({ tag, closePopup }) => {
    const translate = useTranslator('popup', 'tags.edit');
    const dispatch = useDispatch();

    const handleDeleteTag = () => {
        if (!tag) return;

        dispatch(deleteTag(tag.id));
        closePopup();
    };

    return (
        <div className="TagDeleteButton mt-2">
            <div className="w-full flex cursor-pointer" onClick={handleDeleteTag}>
                <Icon name="task-trash" />
                <span className="text-sm ml-1">{translate('delete')}</span>
            </div>
        </div>
    );
};

export default TagDeleteButton;
